"use client";
import React, { ReactNode } from "react";

import StoreDetails from "./StoreDetails/StoreDetails";
import MapLoader from "../MapLoader/MapLoader";
import MapUnavailableMessage from "../MapLoader/MapUnavailableMessage/MapUnavailableMessage";
import {
  mapFormatStores,
} from "../MapLoader/mapLoaderUtils/mapLoaderUtils";
import { TFormatStore } from "../wrappers/StoreLocatorWrapper/StoreLocatorUtils/StoreLocatorUtils";
import styles from "./SpecificStore.module.scss";
import { isSafari13OrLower } from "../MapLoader/mapLoaderUtils/mapLoaderClientUtils";

type TSpecificStorePure = {
  specificStore?: TFormatStore;
  stores: TFormatStore[];
  message: ReactNode;
  mapKey: string;
};

const SpecificStore = ({
  specificStore,
  stores,
  message,
  mapKey,
}: TSpecificStorePure) => {
  const location = specificStore ? mapFormatStores([specificStore]) : undefined;

  return (
    <section className={styles.wrapper}>
      {message}
      <div className={styles.details}>
        {specificStore && (
          <div>
            <StoreDetails storeDetails={specificStore} />
          </div>
        )}
        {stores &&
          (isSafari13OrLower() ? (
            <div className={styles.mapMessage}>
              <MapUnavailableMessage />
            </div>
          ) : (
            <div className={styles.map}>
              <MapLoader
                location={location ? location[0] : undefined}
                stores={mapFormatStores(stores)}
                mapKey={mapKey}
              />
            </div>
          ))}
      </div>
    </section>
  );
};

export default SpecificStore;
